import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { Field, Formik, FormikProvider, useFormik } from 'formik'
import CustomInput from '../../../components/common/CustomInput'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  name: Yup.string().trim().required('Color Name is required'),
  code: Yup.string().trim().required('Color Code is required'),
})

const Add = () => {
  const navigate = useNavigate()

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = axiosAuthInstance.post('color/add', {
        name: values.name,
        code: values.code
      })
      if (response) {
        navigate('/color')
      }
    } catch (error) {
      console.log(error)
    }
  }
  const formik = useFormik({
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
    validationSchema,
    initialValues: {
      name: '',
      code: '',
    },
  })

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name='name'
          label='Color Name'
          placeholder='Color Name'
          required
          component={CustomInput}
        />

        <Field
          name='code'
          label='Color Code'
          placeholder='Color Code (#FFF)'
          required
          component={CustomInput}
        />

        <button
          type='submit'
          disabled={formik.isSubmitting}
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          Add
        </button>
      </form>
    </FormikProvider>
  )
}

export default Add
